import i18n from "i18next";

export const getLang = (): string => {
	const currentLang = i18n.language;
	return currentLang || "en";
};
